module.exports = "pegasus_template/assets/themecapture1/webinar/104.png";